module.exports = __webpack_public_path__ + "img/housing.a2265e1e.png";